<template>
  <a-modal
    :open="updateVisible"
    title="修改角色名称"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
  >
    <a-form :model="formState" :rules="rules">
      <a-form-item :wrapper-col="{ span: 14 }" name="name" label="输入角色名称">
        <a-input
          v-model:value="formState.name"
          placeholder="请输入"
          autocomplete="off"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { reactive, toRefs, inject, watchEffect } from 'vue'
export default {
  setup() {
    const updateState = inject('updateModal')

    // const formState = reactive({
    //   name: ''
    // })

    watchEffect(() => {
      // if (updateState.updateVisible) {
      //   updateState.formState.name = updateState.name
      // }
    })

    const rules = reactive({
      name: [
        { required: true, message: '请输入' },
        { min: 0, max: 60 }
      ]
    })

    return {
      // formState,
      rules,
      ...toRefs(updateState)
    }
  }
}
</script>
<style lang="scss" scoped></style>
